import { PrimaryButton, PrimaryButtonProps } from '@components/Buttons/primary';
import { call } from '@packages/functions';
import { createMemo } from '@packages/react';
import { useTabs } from '@packages/tabs/lib/useTabs';
import React, { ReactElement, useCallback } from 'react';

/**
 * Go to previous tab
 * @param props
 * @returns {*}
 * @constructor
 */
export const PreviousTab = createMemo<PrimaryButtonProps>(
    ({ component, onClick, ...props }): ReactElement => {
        props.children = props.children ?? 'Previous';

        const { previousTab } = useTabs();
        const Component = component ?? PrimaryButton;

        const handleClick = useCallback(
            async (e) => {
                await call(onClick, e);
                await previousTab();
            },
            [previousTab, onClick],
        );

        return <Component onClick={handleClick} {...props} />;
    },
    {
        displayName: 'PreviousTab',
    },
);

/**
 * PreviousTab alias
 * @type {*}
 */
export const PrevTab = PreviousTab;
